var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAu = function SvgAu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001E5E",
    d: "M24 0H0v16h24V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000158",
    d: "M12.805 0H0v7.945h12.805V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.532 7.945H0v-.88L11.267 0h1.538v.877L1.532 7.945Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1.43l11.375 7.048v.897h-1.518L0 .951V0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M7.454 3.31V2.76L11.852 0h.952l-5.35 3.31ZM0 7.945l5.18-3.157h.208l-.047.45-4.317 2.707H0ZM7.738 4.788h.943l4.123 2.555v.602L7.738 4.788ZM5.149 3.183h-.995L0 .608V0l5.149 3.183Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.805 2.635H0v2.661h12.805v-2.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.501 0H5.388v7.945H7.5V0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M12.805 3.183H0v1.605h12.805V3.183Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M7.044 0H5.72v7.945h1.324V0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFC",
    d: "m19.259 1.563.19.6.5-.188-.26.558.428.367-.513.098.037.644-.382-.439-.383.439.038-.644L18.4 2.9l.43-.367-.26-.558.498.188.192-.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F9",
    d: "m20.525 8.001.158.395.352.063-.255.31.061.434-.316-.205-.314.205.059-.435-.255-.309.352-.063.158-.395Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFC",
    d: "m22.129 4.816.192.602.497-.19-.26.56.43.365-.514.098.037.644-.382-.439-.383.439.038-.644-.514-.098.43-.364-.26-.56.498.189.19-.602ZM16.052 5.922l.192.6.497-.19-.258.56.429.365-.516.098.038.646-.383-.439-.382.439.038-.646-.514-.098.43-.364-.26-.56.498.189.19-.6ZM19.259 12.235l.19.602.5-.19-.26.56.428.365-.513.098.037.644-.382-.439-.383.439.038-.644-.515-.098.43-.364-.26-.56.498.189.192-.602ZM6.445 9.713l.397 1.25 1.035-.395-.54 1.164.892.758-1.069.203.079 1.338-.794-.91-.795.91.079-1.338-1.069-.203.893-.758-.54-1.164 1.035.395.397-1.25Z"
  })));
};
export default SvgAu;